import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UnassignAccountEntitlementsResultModal} from './unassign-account-entitlements.result.modal';
import {
    clearResult,
    selectUnassignAccountEntitlementsBulkUuid,
    selectUnassignAccountEntitlementsShown,
    selectUnassignAccountEntitlementsTask,
} from './unassign-account-entitlements.slice';


export const UnassignAccountEntitlementsResult = () => (
    <BulkActionResult
        actionIdSelector={selectUnassignAccountEntitlementsBulkUuid}
        actionTaskSelector={selectUnassignAccountEntitlementsTask}
        actionShownSelector={selectUnassignAccountEntitlementsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <UnassignAccountEntitlementsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
